/* RM · UI compartida — tarjetas (slider + añadir rápido por talla), rejilla, modelo/prenda, filtros y "ver más" */
(function () {
  if (window.RMUI) return;
  var RMUI = window.RMUI = {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Slider de imágenes ---------- */
  function syncSlider(s) {
    var card = s.closest('[data-rm-card]');
    if (!card) return;
    var w = s.clientWidth || 1;
    var idx = Math.round(s.scrollLeft / w);
    var prev = card.querySelector('[data-rm-slide-nav="-1"]');
    var next = card.querySelector('[data-rm-slide-nav="1"]');
    if (prev) prev.disabled = s.scrollLeft < 4;
    if (next) next.disabled = s.scrollLeft + s.clientWidth >= s.scrollWidth - 4;
    var dots = card.querySelectorAll('.rm-pcard__dots span');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-rm-slides]')) syncSlider(t);
  }, true);

  /* ---------- Añadir a la cesta ---------- */
  function closeSizes(except) {
    document.querySelectorAll('[data-rm-sizes].is-open').forEach(function (p) {
      if (p === except) return;
      p.classList.remove('is-open');
      var b = p.parentNode.querySelector('.rm-pcard__add');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function openCart() {
    var icon = Array.prototype.find.call(document.querySelectorAll('[data-js-cart-icon]'), function (el) { return el.offsetParent !== null; });
    if (icon) icon.click();
  }
  RMUI.addToCart = function (variantId, btn, card) {
    if (btn) btn.classList.add('is-loading');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        closeSizes();
        var add = card && card.querySelector('.rm-pcard__add');
        if (add) {
          add.classList.add('is-added');
          add.setAttribute('aria-expanded', 'false');
          setTimeout(function () { add.classList.remove('is-added'); }, 2200);
        }
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: data }));
        document.dispatchEvent(new CustomEvent('rm:cart-added', { detail: data }));
        if (!document.body.classList.contains('template-cart') && !document.querySelector('[data-rm-cart]')) setTimeout(openCart, 450);
        return data;
      })
      .catch(function (err) {
        var msg = card && card.querySelector('[data-rm-msg]');
        if (msg) { msg.textContent = (err && (err.description || err.message)) || 'Error'; msg.style.display = 'block'; }
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  };

  /* ---------- Modelo / prenda ---------- */
  RMUI.applyMode = function (mode) {
    document.querySelectorAll('img[data-flat-src]').forEach(function (img) {
      if (img.dataset.rmSrcset === undefined) img.dataset.rmSrcset = img.getAttribute('srcset') || '';
      if (mode === 'flat') {
        img.removeAttribute('srcset');
        if (img.dataset.flatSrc) img.src = img.dataset.flatSrc;
      } else {
        if (img.dataset.modelSrc) img.src = img.dataset.modelSrc;
        if (img.dataset.rmSrcset) img.setAttribute('srcset', img.dataset.rmSrcset);
      }
    });
    document.querySelectorAll('[data-rm-mode]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.rmMode === mode); b.setAttribute('aria-pressed', b.dataset.rmMode === mode ? 'true' : 'false'); });
    document.documentElement.setAttribute('data-rm-view', mode);
  };

  /* ---------- Densidad de rejilla ---------- */
  RMUI.applyDensity = function (d) {
    document.querySelectorAll('[data-rm-grid-target]').forEach(function (g) { g.setAttribute('data-rm-density', d); });
    document.querySelectorAll('[data-rm-density-btn]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.rmDensityBtn === d); b.setAttribute('aria-pressed', b.dataset.rmDensityBtn === d ? 'true' : 'false'); });
  };

  /* ---------- Ver más ---------- */
  function loadMore(btn) {
    var url = btn.dataset.rmLoadMore;
    var gridId = btn.dataset.rmGrid;
    if (!url || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.getElementById(gridId);
      var dest = document.getElementById(gridId);
      if (src && dest) Array.prototype.forEach.call(src.children, function (c) { dest.appendChild(document.importNode(c, true)); });
      var nb = doc.querySelector('[data-rm-load-more][data-rm-grid="' + gridId + '"]');
      if (nb && nb.dataset.rmLoadMore) { btn.dataset.rmLoadMore = nb.dataset.rmLoadMore; btn.classList.remove('is-loading'); }
      else { var wrap = btn.closest('.rm-more'); if (wrap) wrap.remove(); else btn.remove(); }
      if (document.documentElement.getAttribute('data-rm-view') === 'flat') RMUI.applyMode('flat');
      if (RMUI.observeMore) RMUI.observeMore();
    }).catch(function () { btn.classList.remove('is-loading'); });
  }
  RMUI.observeMore = function () {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-rm-load-more][data-rm-auto="true"]').forEach(function (b) {
      if (b.__rmObs) return;
      b.__rmObs = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) loadMore(b); }); }, { rootMargin: '600px 0px' });
      b.__rmObs.observe(b);
    });
  };

  /* ---------- Filtros ---------- */
  function submitFilters(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var q = params.toString();
    window.location.href = form.getAttribute('action') + (q ? (form.getAttribute('action').indexOf('?') > -1 ? '&' : '?') + q : '');
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    var form = input.closest && input.closest('form[data-rm-filters]');
    if (form && input.matches('input[type="checkbox"]')) submitFilters(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-rm-filters]');
    if (form) { e.preventDefault(); submitFilters(form); }
  });

  /* ---------- Click delegado ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var nav = t.closest('[data-rm-slide-nav]');
    if (nav) {
      e.preventDefault();
      var s = nav.closest('[data-rm-card]').querySelector('[data-rm-slides]');
      s.scrollBy({ left: Number(nav.dataset.rmSlideNav) * s.clientWidth, behavior: 'smooth' });
      return;
    }
    var size = t.closest('.rm-pcard__size');
    if (size) {
      e.preventDefault();
      if (!size.disabled) RMUI.addToCart(size.dataset.variantId, size, size.closest('[data-rm-card]'));
      return;
    }
    var add = t.closest('.rm-pcard__add');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var card = add.closest('[data-rm-card]');
      if (add.dataset.variantId) { RMUI.addToCart(add.dataset.variantId, add, card); return; }
      var panel = card.querySelector('[data-rm-sizes]');
      if (!panel) { var a = card.querySelector('a[href]'); if (a) window.location.href = a.href; return; }
      var open = !panel.classList.contains('is-open');
      closeSizes(panel);
      panel.classList.toggle('is-open', open);
      add.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!t.closest('[data-rm-sizes]')) closeSizes();

    var mode = t.closest('[data-rm-mode]');
    if (mode) { e.preventDefault(); RMUI.applyMode(mode.dataset.rmMode); store.set('rmView', mode.dataset.rmMode); return; }
    var dens = t.closest('[data-rm-density-btn]');
    if (dens) { e.preventDefault(); RMUI.applyDensity(dens.dataset.rmDensityBtn); store.set('rmDensity', dens.dataset.rmDensityBtn); return; }
    var more = t.closest('[data-rm-load-more]');
    if (more) { e.preventDefault(); loadMore(more); return; }
    var sort = t.closest('[data-rm-sort]');
    if (sort) {
      e.preventDefault();
      var f = document.getElementById(sort.dataset.rmForm);
      if (f) { var hid = f.querySelector('input[name="sort_by"]'); if (hid) hid.value = sort.dataset.rmSort; submitFilters(f); }
      return;
    }
    document.querySelectorAll('details.rm-drop[open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSizes(); document.querySelectorAll('details.rm-drop[open]').forEach(function (d) { d.removeAttribute('open'); }); } });

  function init() {
    var v = store.get('rmView'); if (v && document.querySelector('[data-rm-mode]')) RMUI.applyMode(v);
    var d = store.get('rmDensity'); if (d && document.querySelector('[data-rm-density-btn]')) RMUI.applyDensity(d);
    RMUI.observeMore();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
